import React from 'react';

const Education = () => {
    return (
        <div id="education-content">
            <div className="mb-4">
                <h1 className="text-5xl font-bold">Education</h1>
            </div>
            <div id="educational-details">
                <p className="text-lg font-semibold">Bachelor's Degree of Science in Information Technology - Software Engineering</p>
                <p className="text-md">AMA - Makati Campus</p>
                <p className="text-md">2015-2018</p>
            </div>
        </div>
    )
}

export default Education;
